import React from 'react';
import PropTypes from 'prop-types';
import {KeyboardDatePicker} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import LabelValue from '../../../shared/labelvalue/LabelValue.js';
import {FORMATO_DATA_TELA} from '../processo/processoSelecao.js';

/*
 * Campos comuns das telas de Carga SAF (estado na própria tela): processo
 * seletivo, data da chamada (dd/mm/aaaa; precisa de um MuiPickersUtilsProvider
 * acima) e chamada do Prouni.
 */

/* Rótulo com " *" quando o campo é obrigatório. */
const rotulo = (texto, obrigatorio) => (obrigatorio ? `${texto} *` : texto);

/* Sem `obrigatorio`, a opção vazia fica selecionável com o texto `textoVazio` (ex.: "Todos"). */
export function CampoProcessoSeletivo({valor, opcoes, onChange, disabled = false, sm = 6, obrigatorio = true, textoVazio = 'Selecione...', label = 'Processo Seletivo'}) {
    return (
        <Grid item xs={12} sm={sm}>
            <LabelValue label={rotulo(label, obrigatorio)}>
                <FormControl variant='outlined' fullWidth disabled={disabled}>
                    <Select value={valor} onChange={evento => onChange(evento.target.value)} displayEmpty>
                        <MenuItem value='' disabled={obrigatorio}><em>{textoVazio}</em></MenuItem>
                        {opcoes.map(opcao => (
                            <MenuItem key={opcao.id} value={String(opcao.id)}>{opcao.descricao}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </LabelValue>
        </Grid>
    );
}

CampoProcessoSeletivo.propTypes = {
    valor: PropTypes.string.isRequired,
    opcoes: PropTypes.arrayOf(PropTypes.shape({id: PropTypes.number, descricao: PropTypes.string})).isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    sm: PropTypes.number,
    obrigatorio: PropTypes.bool,
    textoVazio: PropTypes.string,
    label: PropTypes.string
};

/* Sem `obrigatorio`, o calendário ganha o botão "Limpar". */
export function CampoDataChamada({valor, onChange, disabled = false, sm = 3, obrigatorio = true}) {
    return (
        <Grid item xs={12} sm={sm}>
            <LabelValue label={rotulo('Data da Chamada', obrigatorio)}>
                <KeyboardDatePicker
                    value={valor}
                    onChange={data => onChange(data)}
                    format={FORMATO_DATA_TELA}
                    placeholder='dd/mm/aaaa'
                    mask='__/__/____'
                    clearable={!obrigatorio}
                    clearLabel='Limpar'
                    cancelLabel='Cancelar'
                    okLabel='OK'
                    invalidDateMessage='Data inválida'
                    inputVariant='outlined'
                    disabled={disabled}
                    fullWidth/>
            </LabelValue>
        </Grid>
    );
}

CampoDataChamada.propTypes = {
    valor: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    sm: PropTypes.number,
    obrigatorio: PropTypes.bool
};

export function CampoChamada({valor, opcoes, onChange, disabled = false, sm = 3}) {
    return (
        <Grid item xs={12} sm={sm}>
            <LabelValue label='Chamada *'>
                <FormControl variant='outlined' fullWidth disabled={disabled}>
                    <Select value={valor} onChange={evento => onChange(evento.target.value)} displayEmpty>
                        <MenuItem value='' disabled><em>Selecione...</em></MenuItem>
                        {opcoes.map(opcao => <MenuItem key={opcao} value={opcao}>{opcao}</MenuItem>)}
                    </Select>
                </FormControl>
            </LabelValue>
        </Grid>
    );
}

CampoChamada.propTypes = {
    valor: PropTypes.string.isRequired,
    opcoes: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    sm: PropTypes.number
};
